import { render, staticRenderFns } from "./DatingStatusCheckPage.vue?vue&type=template&id=21b5aa9c&scoped=true"
import script from "./DatingStatusCheckPage.vue?vue&type=script&lang=js"
export * from "./DatingStatusCheckPage.vue?vue&type=script&lang=js"
import style0 from "./DatingStatusCheckPage.vue?vue&type=style&index=0&id=21b5aa9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b5aa9c",
  null
  
)

export default component.exports